import { render, staticRenderFns } from "./disease_result.vue?vue&type=template&id=3942485c&scoped=true"
import script from "./disease_result.vue?vue&type=script&lang=js"
export * from "./disease_result.vue?vue&type=script&lang=js"
import style0 from "./disease_result.vue?vue&type=style&index=0&id=3942485c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942485c",
  null
  
)

export default component.exports